import { TilesetsByLayer } from '@/api/rest/resources/conservation';

import { useConservationFile } from './useConservation';
import { useConservationProjectName } from './useConservationProjectName';

export const useTilesetsByLayer = () => {
  const projectName = useConservationProjectName();

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  return useConservationFile<TilesetsByLayer>({
    projectName,
    fileName: 'tilesets.json',
  });
};
